import React from "react";
export default function Dashboard() {
  return (
    <div>
      <p className="text-white">Dashboard</p>
    </div>
  );
}